export type QuickRepliesSize = "default" | "compact";

export const getQuickRepliesConfig = (size: QuickRepliesSize) =>
  ({
    width: size === "compact" ? "280px" : "480px",
    offset: size === "compact" ? "top-center" : "top-left",
  } as const);
